import { MessageService } from 'primeng/api';
import { NoAuthorizationInterceptor } from 'src/app/util/interceptor/NoAuthorizationInterceptor';
import { PrincipalBaseComponent } from 'src/app/util/PrincipalBaseComponent';
import { WhAlmacenmastService } from './../../whalmacenmast/servicio/whalmacenmast.servicio';
import { FiltroWhItemMast } from './../dominio/FiltroWhItemMast';
import { Component, OnInit, ViewChild } from '@angular/core';
import { WhItemMastServicio } from '../servicio/WhItemMast.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CoCotizacion } from 'src/app/erp/comercial/cotizacion/dominio/CoCotizacion';
import { CoDocumento } from 'src/app/erp/comercial/codocumento/dominio/CoDocumento';

@Component({
    selector: 'app-item-inventario',
    templateUrl: './whitemmast-inventario.component.html'
})
export class WhItemInventarioComponent extends PrincipalBaseComponent implements OnInit {
    filtro: FiltroWhItemMast = new FiltroWhItemMast();
    item: string;
    desc: string;
    rowGroupMetadata: any;
    rowGroupMetadata2: any;
    grupo1: any;
    subscribedParam = 'initial value';
    subscribedParam2 = 'initial value';
    subscribedParam3 = 'initial value';
    origen: string;
    coCotizacion: CoCotizacion = new CoCotizacion();
    coDocumento: CoDocumento = new CoDocumento();
    acction: string;
    verdescuentos: string;
    verModal:Boolean=false;

    constructor(
        private itemService: WhItemMastServicio,
        private itemAlamcenMast: WhAlmacenmastService,
        private readonly route: ActivatedRoute,
        private router: Router,
        noAuthorizationInterceptor: NoAuthorizationInterceptor,
        messageService: MessageService
    ) { super(noAuthorizationInterceptor, messageService); }

    ngOnInit() {
    }

iniciarModal(item:string,desc:string,codigo:string){
    this.item = item;
    this.desc = desc;
    //this.filtro.codigo = codigo;
    this.filtro.codigo = item;
    this.cargarInventario(); 
}

    cargarInventario() {
        this.bloquearPagina();
        this.itemAlamcenMast.listarItemInventarioPaginacion(this.filtro).then(res => {
            this.filtro.paginacion = res;
            this.updateRowGroupMetaData();
            this.desbloquearPagina();
            this.verModal=true;
        });
    }


    onSort() {
        this.updateRowGroupMetaData();
    }



    updateRowGroupMetaData() {
        this.rowGroupMetadata = {};
        this.grupo1 = {};
        this.rowGroupMetadata2 = {};
        const itemPag = this.filtro.paginacion.listaResultado;
        if (this.filtro.paginacion.listaResultado) {
            for (let i = 0; i < itemPag.length; i++) {
                let rowData = itemPag[i];
                let almacenCodigo = rowData.almacenCodigo;
                if (i == 0) {
                    this.rowGroupMetadata[almacenCodigo] = { index: 0, size: 1 };
                } else {
                    let previousRowData = itemPag[i - 1];
                    let previousRowGroup = previousRowData.almacenCodigo;
                    if (almacenCodigo === previousRowGroup) {
                        this.rowGroupMetadata[almacenCodigo].size++;
                        // SEGUNDO ROW GROUP
                    }//FIN IF ITEMPROCEDENCIA
                    else
                        this.rowGroupMetadata[almacenCodigo] = { index: i, size: 1 };
                }
            }
        }
        //------ this.filtro.paginacion.listaResultado
        if (this.filtro.paginacion.listaResultado) {
            for (let i = 0; i < itemPag.length; i++) {
                let rowData2 = itemPag[i];
                let nombrealmacenCodigo = rowData2.nombrealmacenCodigo;
                if (i == 0) {
                    this.rowGroupMetadata2[nombrealmacenCodigo] = { index: 0, size: 1 };
                }
                else {
                    let previousRowData2 = itemPag[i - 1];
                    let previousRowGroup2 = previousRowData2.nombrealmacenCodigo;
                    if (nombrealmacenCodigo === previousRowGroup2) {
                        this.rowGroupMetadata2[nombrealmacenCodigo].size++;
                        // SEGUNDO ROW GROUP
                    }//FIN IF ITEMPROCEDENCIA
                    else
                        this.rowGroupMetadata2[nombrealmacenCodigo] = { index: i, size: 1 };
                }
            }
        }
    }

    cancelar() {

        if (this.origen === 'PEDIDO') {
            this.router.navigate(['royal/item-listado', this.origen, this.subscribedParam3.trim(), JSON.stringify(this.coDocumento), this.acction, this.verdescuentos], { skipLocationChange: true });
        } else if (this.origen === 'COTIZACION') {
            this.router.navigate(['royal/item-listado', this.origen, this.subscribedParam3.trim(), JSON.stringify(this.coCotizacion), this.acction, this.verdescuentos], { skipLocationChange: true });
        }
    }


}
